import { Duration } from 'js-joda';

import { MassagedBusiness } from 'types/service';
import { pick } from 'es-toolkit/compat';
import { setActiveBusinessCookie } from 'utils/businessCookieUtils';
import settings from 'settings/AppSettings';

export function setActiveBusinessCookieHelper(business: MassagedBusiness): void {
  const expirationInMs = Duration.ofDays(7).toMillis();
  const dataToSave = pick(business, [
    'id',
    'businessGroupId',
    'currencyCode',
    'emailLogoUrl',
    'hasPosIntegration',
    'locale',
    'name',
    'roles',
    'timeZone',
  ]);
  setActiveBusinessCookie(settings.WSS_BASE, dataToSave, expirationInMs);
}
